import { render, staticRenderFns } from "./PersistGithubOrganizationView.vue?vue&type=template&id=8ea8425a"
import script from "./PersistGithubOrganizationView.vue?vue&type=script&lang=ts"
export * from "./PersistGithubOrganizationView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports